import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const adminerDatabasePlugin = createPlugin({
  id: 'adminer-database',
  routes: {
    root: rootRouteRef,
  },
});

export const AdminerDatabaseComponent = adminerDatabasePlugin.provide(
  createComponentExtension({
    name: 'AdminerDatabaseComponent',
    component: {
      lazy: () =>
        import('./components/AdminerDatabaseComponent').then(
          m => m.AdminerDatabaseComponent,
        ),
    },
  }),
);
